<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <div style="width: 120px">
    <tui-textfield [iconStart]="'@tui.paintbrush'" tuiTextfieldSize="m" [tuiTextfieldCleaner]="false">
      <input placeholder="#000000" tuiInputColor [(ngModel)]="value"/>
    </tui-textfield>
  </div>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
